import { render, staticRenderFns } from "./ProductPriceSection.vue?vue&type=template&id=d6c5fe04&scoped=true"
import script from "./ProductPriceSection.vue?vue&type=script&lang=js"
export * from "./ProductPriceSection.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceSection.vue?vue&type=style&index=0&id=d6c5fe04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c5fe04",
  null
  
)

export default component.exports